module.exports = __webpack_public_path__ + "img/up_arrow.81d69681.svg";